import { getContactFormSlugFromUrl } from 'app/utils/contactFormUrl';
import { create } from 'zustand';

interface ContactFormState {
  isOpen: boolean;
  contactFormSlug?: string;
  openContactForm: (refSlug?: string) => void;
  closeContactForm: () => void;
}

export const useContactFormStore = create<ContactFormState>((set) => {
  const tailorUrlQueryParam = new URLSearchParams(window.location.search).get('tailorUrl');

  const contactFormSlug = getContactFormSlugFromUrl(tailorUrlQueryParam?.replace('/', '#')) ?? '';

  return {
    isOpen: !!tailorUrlQueryParam?.startsWith('/contact-form'),
    contactFormSlug,
    openContactForm: (slug?: string) => set({ isOpen: true, contactFormSlug: slug ?? '' }),
    closeContactForm: () => set({ isOpen: false, contactFormSlug: '' }),
  };
});

export default useContactFormStore;
